/* @flow */
import {
  RECORD_SEARCH_TERM,
  FINISH_FETCHING,
  SET_LAST_FETCHED_LOCATION,
  UNSET_INITIAL_PAGEVIEW
} from '../actions/api';
import {
  FETCH_FOUNDRY_RESPONSE,
  RECEIVE_FOUNDRY_RESPONSE,
  RECEIVE_MORE_CONTENT_FOUNDRY_RESPONSE,
  RECEIVE_BAD_FOUNDRY_RESPONSE
} from '../actions/foundry_response';
import type {
  LastFetchedLocation
} from '../actions/api';
import type { Pagination, FetchType } from '../actions/foundry_response';
import type { Action } from '../actions/types';
import {get} from 'lodash';

const initialState = {
  fetchStatus: 'notFetching',
  isInitialPageview: true,
  lastFetchedLocation: {
    pathname: '',
    query: {}
  },
  searchTerm: ''
};

export default (state: ApiState = initialState, action: Action): ApiState => {
  switch (action.type) {
    case FETCH_FOUNDRY_RESPONSE:
      return {
        ...state,
        fetchStatus: action.fetchType
      };
    case RECEIVE_BAD_FOUNDRY_RESPONSE:
      return {
        ...state,
        fetchStatus: 'notFetching',
        status: action.status,
        hasErrors: true,
        fetchStatusBeforeError: state.fetchStatus,
        errorMessage: action.errorMessage
      };
    case RECEIVE_FOUNDRY_RESPONSE:
      return {
        ...state,
        pagination: { ...action.pagination },
        status: action.status,
        headers: action.headers || {},
        hasErrors: false,

        /*
         * Do NOT set 'fetchStatus' to 'notFetching' here. Our routing code is
         * responsible for doing that. This is because as part of a route
         * change, we might need to load a different Webpack bundle -- that
         * should count as part of fetching. The FINISH_FETCHING action
         * will be dispatched after that is done.
         */

        // Used for our search page
        searchTerm: get(action.data, 'page_data.search_term')
      };
    case FINISH_FETCHING:
      return {
        ...state,
        fetchStatus: 'notFetching'
      };
    case RECEIVE_MORE_CONTENT_FOUNDRY_RESPONSE:
      return {
        ...state,
        pagination: { ...state.pagination, ...action.pagination },
        status: action.status,
        hasErrors: false,

        /*
         * Unlike 'RECEIVE_FOUNDRY_RESPONSE', we do set 'fetchStatus' to
         * 'notFetching' for this action. If the user clicked the More
         * Stories button then we know that a route change did not happen.
         */
        fetchStatus: 'notFetching'
      };
    case RECORD_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.searchTerm
      };
    case SET_LAST_FETCHED_LOCATION:
      return {
        ...state,
        lastFetchedLocation: action.location
      };
    case UNSET_INITIAL_PAGEVIEW:
      return {
        ...state,
        isInitialPageview: false
      };
    default:
      return state;
  }
};

type ApiState = {
  fetchStatus: FetchType | 'notFetching',
  isInitialPageview: bool,
  pagination?: Pagination,
  searchTerm: string,
  status?: number|null,
  hasErrors?: bool,
  /*
   * `fetchStatusBeforeError` cannot actually be 'notFetching', because
   * logically, there's no way that you could get an error if you didn't
   * attempt a fetch. It just makes the type checker happy to make it the
   * same type as `fetchStatus`.
   */
  fetchStatusBeforeError?: FetchType | 'notFetching',
  lastFetchedLocation: LastFetchedLocation
};
